import { useOnboardingStepsCompleted, useUserPreferences } from "@/api";
import { cn } from "@/lib/utils";
import { motion, AnimatePresence } from "framer-motion";
import { Check, LucideProps, Sparkles } from "lucide-react";

interface Props extends LucideProps {}

export function OnboardingSidebarIcon({ ...props }: Props) {
  const { data } = useUserPreferences();
  const { completedPercentage, isOnboardingCompleted } =
    useOnboardingStepsCompleted();

  return (
    <div className="relative">
      <AnimatePresence>
        {!isOnboardingCompleted && !data?.onboardingDisabled && (
          <motion.div
            className="absolute -inset-2 rounded-full"
            style={{
              background: `conic-gradient(rgb(56 189 248) ${completedPercentage}%, transparent ${completedPercentage}%, transparent 100%)`
            }}
            animate={{ scale: 1, opacity: 1 }}
            exit={
              isOnboardingCompleted ? { scale: 1.5, opacity: 0 } : { inset: 0 }
            }
          />
        )}
      </AnimatePresence>
      <div className="absolute -inset-1 rounded-full dark:bg-brand-gray-950 bg-white" />
      {isOnboardingCompleted && !data?.onboardingDisabled && (
        <Check
          size={13}
          strokeWidth={4}
          className="absolute -top-1 -right-1 text-brand-primary"
        />
      )}
      <Sparkles
        {...props}
        className={cn(
          props.className,
          "relative transition-colors",
          isOnboardingCompleted || data?.onboardingDisabled
            ? "text-brand-gray-400 dark:text-brand-gray-300"
            : "text-brand-primary"
        )}
        fill={
          isOnboardingCompleted || data?.onboardingDisabled
            ? "none"
            : "currentColor"
        }
      />
    </div>
  );
}
